module.exports = __webpack_public_path__ + "img/05-BABO-m.594fe8bd.png";